import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl = endpointNames.report;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

const dashboardData = async () => {
    let response;


    await axios.get(baseUrl.dashboard, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

export default {
    dashboardData
}
